module.exports = __webpack_public_path__ + "img/logo-um-fkbv-ang.90cbe5b9.png";